module.exports = __webpack_public_path__ + "img/public_button_return_grey.9380e975.svg";